module.exports = __webpack_public_path__ + "img/page-devices-qrcode-car.f368a7a4.png";